





















































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { AxiosResponse } from 'axios';
import moment, { Moment } from 'moment';
import storage from 'baimahu/storage';
const { VUE_APP_FCAPI: FCAPI } = process.env;
const API = {
  query: `${FCAPI}/shang/promotion/coupon`,
  ware_list: `${FCAPI}/shang/ware`,
  coupon_ware_list: `${FCAPI}/shang/promotion/coupon/ware`,
  add: `${FCAPI}/shang/promotion/coupon`,
};
const _ = {
  flatMap: require('lodash/flatMap'),
};
@Component
export default class ConfigSecond extends Vue {
  is_loading: boolean = false;
  config_form_layout: any = {
    labelCol: { span: 3 },
    wrapperCol: { span: 21 },
  };
  show_list: any = [
    {
      value: '1',
      label: '商品详情页',
    },
  ];
  coupon_type: any = '';
  form: any = {
    name: {},
    threshold: 2,
    threshold_price_first: {
      data: '',
    },
    threshold_price_second: {},
    discount_first: {
      data: '',
    },
    discount_second: {},
    max_amount: 2,
    amount: {
      data: '',
    },
    range: 1,
    expire_type: 1,
    time: {
      start_time: '',
      end_time: '',
    },
    expire_days_a: {
      data: '',
    },
    expire_days_b: {
      data: '',
    },
    description: '',
    received_number: 0,
    stock: {
      data: '',
    },
    limit_type: 2,
    limit_number: {
      data: 1,
    },
    is_overlay: 1,
    is_show: [1],
  };
  coupon_ware_list: any = {
    detail: [],
  };
  coupon_ware_list_current_page: number = 1;
  ware_loading: boolean = false;
  modal_name: string = '';
  ware_list: any = [];
  all_ware_list: any = [];
  is_show_ware_modal: boolean = false;
  is_show_range_error: boolean = false;
  is_show_remove_modal: boolean = false;
  remove_index: number = 0;
  selected_checked_list: any = [];
  send_data: any = {};
  button_loading: boolean = false;

  get id(): number {
    const id = Number(this.$route.params.id);
    if (Number.isNaN(id)) {
      return 0;
    }
    return id;
  }
  get isNew() {
    return this.id === 0;
  }

  get CouponWareData(): FcapiRemotePagination<any> {
    const limit = 5;
    const total = this.selected_checked_list.length;
    const current = this.coupon_ware_list_current_page || 1;
    let last = total / limit;
    if (last > ~~last || last === 0) {
      // 不是整数或无数据
      last = ~~last + 1;
    }
    const detail = this.coupon_ware_list.detail.slice(
      (current - 1) * limit,
      current * limit,
    );
    return {
      current,
      detail,
      last,
      limit,
      total,
    };
  }

  @Watch('form.threshold_price_first.data')
  onContentPriceChange(val: string, old_val: string) {
    const value_arr: any[] = String(val).split('.');
    if (!!value_arr[1] && value_arr[1].length > 2) {
      this.form.threshold_price_first.data = old_val;
    }
  }

  @Watch('form.threshold_price_second.data_a')
  onContentPriceSecondChange(val: string, old_val: string) {
    const value_arr: any[] = String(val).split('.');
    if (!!value_arr[1] && value_arr[1].length > 2) {
      this.form.threshold_price_second.data_a = old_val;
    }
  }

  @Watch('form.threshold_price_second.data_b')
  onContentPriceSecondDataChange(val: string, old_val: string) {
    const value_arr: any[] = String(val).split('.');
    if (!!value_arr[1] && value_arr[1].length > 2) {
      this.form.threshold_price_second.data_b = old_val;
    }
  }

  @Watch('form.discount_first.data')
  onContentDiscountChange(val: string, old_val: string) {
    const value_arr: any[] = String(val).split('.');
    if (!!value_arr[1] && value_arr[1].length > 2) {
      this.form.discount_first.data = old_val;
    }
  }

  @Watch('form.discount_second.data_a')
  onContentDiscountSecondChange(val: string, old_val: string) {
    const value_arr: any[] = String(val).split('.');
    if (!!value_arr[1] && value_arr[1].length > 2) {
      this.form.discount_second.data_a = old_val;
    }
  }

  @Watch('form.discount_second.data_b')
  onContentDiscountSecondDataChange(val: string, old_val: string) {
    const value_arr: any[] = String(val).split('.');
    if (!!value_arr[1] && value_arr[1].length > 2) {
      this.form.discount_second.data_b = old_val;
    }
  }

  @Watch('form.amount.data')
  onAmountChange(val: string, old_val: string) {
    const value_arr: any[] = String(val).split('.');
    if (!!value_arr[1] && value_arr[1].length > 2) {
      this.form.amount.data = old_val;
    }
  }

  @Watch('form.range')
  onUseRangeChange(val: any, old_val: string) {
    if (val !== 1) {
      this.getCouponWare();
    }
  }

  checkChange(field: any) {
    let error = '0';
    if (field === 'name') {
      if (!this.form.name.data) {
        this.form.name.status = 'error';
        this.form.name.error = '请输入优惠券名称';
        error = '1';
      } else {
        this.form.name.status = '';
        this.form.name.error = '';
      }
      return error;
    }
    if (
      this.coupon_type === 1 &&
      field === 'threshold_price_first' &&
      this.form.threshold === 2
    ) {
      if (!this.form.threshold_price_first.data) {
        this.form.threshold_price_first.status = 'error';
        this.form.threshold_price_first.error = '请输入金额';
        error = '1';
      } else if (!Number(this.form.threshold_price_first.data)) {
        this.form.threshold_price_first.status = 'error';
        this.form.threshold_price_first.error = '金额必须为大于0的数字';
        error = '1';
      } else if (this.form.threshold_price_first.data <= 0) {
        this.form.threshold_price_first.status = 'error';
        this.form.threshold_price_first.error = '金额必须大于0';
        error = '1';
      } else {
        this.form.threshold_price_first.status = '';
        this.form.threshold_price_first.error = '';
      }
      return error;
    }
    if (
      this.coupon_type === 1 &&
      field === 'threshold_price_second' &&
      this.form.threshold === 1
    ) {
      if (
        !this.form.threshold_price_second.data_a ||
        !this.form.threshold_price_second.data_b
      ) {
        this.form.threshold_price_second.status = 'error';
        this.form.threshold_price_second.error = '请输入金额';
        error = '1';
      } else if (
        !Number(this.form.threshold_price_second.data_a) ||
        !Number(this.form.threshold_price_second.data_b)
      ) {
        this.form.threshold_price_second.status = 'error';
        this.form.threshold_price_second.error = '金额必须为大于0的数字';
        error = '1';
      } else if (this.form.threshold_price_second.data_a <= 0) {
        this.form.threshold_price_second.status = 'error';
        this.form.threshold_price_second.error = '金额必须大于0';
        error = '1';
      } else if (this.form.threshold_price_second.data_b <= 0) {
        this.form.threshold_price_second.status = 'error';
        this.form.threshold_price_second.error = '金额必须大于0';
        error = '1';
      } else {
        this.form.threshold_price_second.status = '';
        this.form.threshold_price_second.error = '';
      }
      return error;
    }
    if (
      this.coupon_type === 2 &&
      field === 'discount_first' &&
      this.form.threshold === 2
    ) {
      if (!this.form.discount_first.data) {
        this.form.discount_first.status = 'error';
        this.form.discount_first.error = '请输入折扣';
        error = '1';
      } else if (!Number(this.form.discount_first.data)) {
        this.form.discount_first.status = 'error';
        this.form.discount_first.error = '折扣必须为大于0的数字';
        error = '1';
      } else if (this.form.discount_first.data <= 0) {
        this.form.discount_first.status = 'error';
        this.form.discount_first.error = '折扣必须大于0';
        error = '1';
      } else {
        this.form.discount_first.status = '';
        this.form.discount_first.error = '';
      }
      return error;
    }
    if (
      this.coupon_type === 2 &&
      field === 'discount_second' &&
      this.form.threshold === 1
    ) {
      if (!this.form.discount_second.data_a) {
        this.form.discount_second.status = 'error';
        this.form.discount_second.error = '请输入金额';
        error = '1';
      } else if (!Number(this.form.discount_second.data_a)) {
        this.form.discount_second.status = 'error';
        this.form.discount_second.error = '金额必须为大于0的数字';
        error = '1';
      } else if (this.form.discount_second.data_a <= 0) {
        this.form.discount_second.status = 'error';
        this.form.discount_second.error = '金额必须大于0';
        error = '1';
      } else if (!this.form.discount_second.data_b) {
        this.form.discount_second.status = 'error';
        this.form.discount_second.error = '请输入折扣';
        error = '1';
      } else if (!Number(this.form.discount_second.data_b)) {
        this.form.discount_second.status = 'error';
        this.form.discount_second.error = '折扣必须为大于0的数字';
        error = '1';
      } else if (this.form.discount_second.data_b <= 0) {
        this.form.discount_second.status = 'error';
        this.form.discount_second.error = '折扣必须大于0';
        error = '1';
      } else {
        this.form.discount_second.status = '';
        this.form.discount_second.error = '';
      }
      return error;
    }
    if (field === 'amount' && this.form.max_amount === 1) {
      if (!this.form.amount.data) {
        this.form.amount.status = 'error';
        this.form.amount.error = '请输入最多优惠金额';
        error = '1';
      } else if (this.form.amount.data <= 0) {
        this.form.amount.status = 'error';
        this.form.amount.error = '优惠金额必须大于0';
        error = '1';
      } else {
        this.form.amount.status = '';
        this.form.amount.error = '';
      }
      return error;
    }
    if (field === 'time' && this.form.expire_type === 1) {
      if (!this.form.time.start_time || !this.form.time.end_time) {
        this.form.time.status = 'error';
        this.form.time.error = '请选择有效日期';
        error = '1';
      } else {
        this.form.time.status = '';
        this.form.time.error = '';
      }
      return error;
    }
    if (field === 'expire_days_a' && this.form.expire_type === 2) {
      if (!this.form.expire_days_a.data) {
        this.form.expire_days_a.status = 'error';
        this.form.expire_days_a.error = '请输入有效期';
        error = '1';
      } else {
        this.form.expire_days_a.status = '';
        this.form.expire_days_a.error = '';
      }
      return error;
    }
    if (field === 'expire_days_b' && this.form.expire_type === 3) {
      if (!this.form.expire_days_b.data) {
        this.form.expire_days_b.status = 'error';
        this.form.expire_days_b.error = '请输入有效期';
        error = '1';
      } else {
        this.form.expire_days_b.status = '';
        this.form.expire_days_b.error = '';
      }
      return error;
    }
    if (field === 'stock') {
      if (!this.form.stock.data) {
        this.form.stock.status = 'error';
        this.form.stock.error = '请输入剩余可发放量';
        error = '1';
      } else {
        this.form.stock.status = '';
        this.form.stock.error = '';
      }
      return error;
    }
    if (field === 'limit_number') {
      if (this.form.limit_type === 2 && !this.form.limit_number.data) {
        this.form.limit_number.status = 'error';
        this.form.limit_number.error = '请输入每人限领次数';
        error = '1';
      } else {
        this.form.limit_number.status = '';
        this.form.limit_number.error = '';
      }
      return error;
    }
  }

  validator() {
    let is_valid = true;
    const valid = [];
    for (const key in this.form) {
      if (key) {
        valid.push(this.checkChange(key));
      }
    }
    this.$forceUpdate();
    if (valid.indexOf('1') !== -1) {
      is_valid = false;
    }
    return is_valid;
  }

  handModalChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    if (next_page !== this.coupon_ware_list_current_page) {
      this.coupon_ware_list_current_page = next_page;
    }
  }

  chosenWareChangePaging(pagination: any, table_filters: any, sorter: any) {
    const next_page = pagination.current;
    this.getWareList(next_page);
  }

  paginationOption(data: FcapiRemotePagination<any>) {
    return {
      total: data.total || 0,
      showTotal: (total: number) => `共${data.total}条，每页${data.limit}条`,
      pageSize: data.limit || 1,
      current: data.current || 1,
    };
  }

  getSendData() {
    const send_data: any = {};
    const form = this.form;
    send_data.type = this.coupon_type;
    send_data.name = form.name.data;
    send_data.threshold = form.threshold; // 是否有订单金额门槛，1是，2否
    if (this.coupon_type === 1) {
      // 类型，1满减券，2折扣券
      if (form.threshold === 1) {
        send_data.threshold_money = form.threshold_price_second.data_a * 100;
      }
      send_data.money =
        form.threshold === 1
          ? form.threshold_price_second.data_b * 100
          : form.threshold_price_first.data * 100;
    } else {
      if (form.threshold === 1) {
        send_data.threshold_money = form.discount_second.data_a * 100;
      }
      send_data.discount =
        form.threshold === 1
          ? form.discount_second.data_b
          : form.discount_first.data;
      send_data.concessions_limit = form.max_amount; // 优惠金额上限，1是，2否
      if (form.max_amount === 1) {
        send_data.concessions_limit_money = form.amount.data * 100;
      }
    }
    send_data.range = form.range;
    if (form.range !== 1) {
      // 1全部商品可用, 2部分商品可用, 3部分商品不可用
      send_data.ware_id = this.selected_checked_list;
    }
    send_data.expire_type = form.expire_type; // 有效期类型：1开始结束时间，2领券当日起天数，3领券次日起天数
    if (form.expire_type === 1) {
      const start_time = form.time.start_time.format('L'); // 格式： 2020/08/26
      const start = new Date(start_time);
      const start_timestamp = new Date(start.toDateString()).getTime(); // start_time的0点时间戳
      const end_time = form.time.end_time.format('L');
      const end = new Date(end_time);
      const end_timestamp =
        new Date(end.toDateString()).getTime() + 24 * 60 * 60 * 1000 - 1; // 第二天0点时间戳减一，表示结束时间为第二天23:59:59
      send_data.start_time = start_timestamp / 1000;
      send_data.end_time = end_timestamp / 1000;
    } else {
      send_data.expire_days =
        form.expire_type === 2
          ? form.expire_days_a.data
          : form.expire_days_b.data;
    }
    send_data.description = form.description;
    send_data.stock = form.stock.data; // 个人限领，1不限制，2限制
    send_data.personal_limit = form.limit_type;
    if (form.limit_type === 2) {
      send_data.personal_limit_number = form.limit_number.data;
    }
    send_data.concessions_overlay = form.is_overlay; // 优惠叠加：1不可叠加，2可叠加
    send_data.shown_place = form.is_show; // 显示优惠券入口
    this.send_data = send_data;
  }

  async submit() {
    if (this.form.range !== 1 && this.coupon_ware_list.detail.length === 0) {
      this.is_show_range_error = true;
    }
    if (!this.validator()) {
      return;
    }
    await this.getSendData();
    if (this.button_loading) {
      return;
    }
    if (this.isNew) {
      this.button_loading = true;
      const res: any = await this.$axios.post(API.add, this.send_data);
      this.button_loading = false;
      if (res.data.status !== 200) {
        this.$message.error(res.data.message);
        return;
      }
      storage.removeItem('coupon_first');
    } else {
      this.button_loading = true;
      const res: any = await this.$axios.put(
        `${API.add}/${this.id}`,
        this.send_data,
      );
      this.button_loading = false;
      if (res.data.status !== 200) {
        this.$message.error(res.data.message);
        return;
      }
    }
    this.$message.success(this.isNew ? '新增成功' : '编辑成功');
    this.$router.push({
      path: '/promotion/coupon',
    });
  }

  async showWareListModal() {
    this.is_show_ware_modal = true;
    this.selected_checked_list = this.coupon_ware_list.detail.map(
      (item: any) => item.id,
    );
    await this.getWareList();
  }

  onRemoveWare(index: number) {
    this.is_show_remove_modal = true;
    this.remove_index = index;
  }

  confirmRemove() {
    const index = this.remove_index;
    const ware_index = index + (this.coupon_ware_list_current_page - 1) * 5;
    this.coupon_ware_list.detail.splice(ware_index, 1);
    const { last, current } = this.CouponWareData;
    if (current > last) {
      this.coupon_ware_list_current_page = last;
    }
    this.selected_checked_list = this.coupon_ware_list.detail.map(
      (item: any) => item.id,
    );
    this.is_show_remove_modal = false;
    this.remove_index = 0;
  }

  async addWare() {
    const add_ware_modal_all_ware_list: any = _.flatMap(
      this.all_ware_list,
      (item: any) => item,
    );
    const selected_id_list = this.selected_checked_list;
    const selected_ware_list = selected_id_list
      .map((id: number) =>
        add_ware_modal_all_ware_list.find((item: any) => item.id === id),
      )
      .filter((item: any) => !!item) as any[];
    let add_ware_list: any = [];
    add_ware_list = selected_ware_list.map((item: any, index: number) => {
      item.sort = index + 1;
      return item;
    });
    this.coupon_ware_list.detail = [
      ...this.coupon_ware_list.detail,
      ...add_ware_list,
    ];
    this.is_show_ware_modal = false;
  }

  handleSelect(selectedRowKeys: any) {
    this.selected_checked_list = selectedRowKeys;
    this.selected_checked_list = Array.from(
      new Set(this.selected_checked_list),
    );
  }

  async getWareList(page: number = 1) {
    this.ware_loading = true;
    const send_data: any = {
      name: this.modal_name,
      current: page,
      limit: 5,
      coupon_id: this.id,
      coupon_ware_exclude: 1,
    };
    const res: any = await this.$axios.get(API.ware_list, {
      params: send_data,
    });
    this.ware_loading = false;
    if (res.data.status !== 200) {
      console.debug(res.data.message);
      return;
    }
    this.ware_list = res.data.data;
    this.all_ware_list = [...this.all_ware_list, ...res.data.data.detail];
    this.all_ware_list = Array.from(new Set(this.all_ware_list));
  }

  async getCouponWare(page: number = 1) {
    if (!this.id) {
      // 新增的时候为空，return
      return;
    }
    const send_data: any = {
      coupon_id: this.id,
      current: page,
      limit: 5,
    };
    const res: any = await this.$axios.get(API.coupon_ware_list, {
      params: send_data,
    });
    if (res.data.status !== 200) {
      console.debug(res.data.message);
      return;
    }
    this.coupon_ware_list = res.data.data;
  }

  // 防止出现 0.1+0.2=0.30000000000000004的情况，整数显示为整数，小数显示两位小数
  numberFormat(num: any) {
    return Number((num / 100).toFixed(2));
  }

  async auery() {
    const res: any = await this.$axios.get(`${API.query}/${this.id}`);
    if (res.data.status !== 200) {
      console.debug(res.data.message);
      return;
    }
    const data = res.data.data;
    const form = this.form;
    this.coupon_type = data.type;
    form.name.data = data.name;
    form.threshold = data.threshold;
    if (data.type === 1) {
      // 满减券
      if (data.threshold === 1) {
        // 1:有门槛，2:无门槛
        form.threshold_price_second.data_a = this.numberFormat(
          data.threshold_money,
        );
        form.threshold_price_second.data_b = this.numberFormat(data.money);
      } else {
        form.threshold_price_first.data = this.numberFormat(data.money);
      }
    } else {
      if (data.threshold === 1) {
        form.discount_second.data_a = this.numberFormat(data.threshold_money);
        form.discount_second.data_b = data.discount;
      } else {
        form.discount_first.data = data.discount;
      }
    }
    if (data.type === 2) {
      form.max_amount = data.concessions_limit;
      if (data.concessions_limit === 1) {
        form.amount.data = this.numberFormat(data.concessions_limit_money);
      }
    }
    form.range = data.range;
    if (data.coupon_ware.length > 0) {
      this.selected_checked_list = [];
      data.coupon_ware.forEach((item: any) => {
        this.selected_checked_list.push(item.ware_id);
      });
    }
    form.expire_type = data.expire_type;
    if (data.expire_type === 1) {
      form.time.start_time = moment(data.start_time * 1000);
      form.time.end_time = moment(data.end_time * 1000 - 1); // 因为结束时间后端存的数据是第二天0点，所以获取数据的时候要减一，不然你会发现提交前结束时间是25号，重新编辑就变成了26号
    } else if (data.expire_type === 2) {
      form.expire_days_a.data = data.expire_days;
    } else {
      form.expire_days_b.data = data.expire_days;
    }
    form.description = data.description;
    form.stock.data = data.stock;
    form.limit_type = data.personal_limit;
    form.received_number = data.received_number;
    if (data.personal_limit === 2) {
      form.limit_number.data = data.personal_limit_number;
    }
    form.is_overlay = data.concessions_overlay;
    form.is_show = data.shown_place;
  }

  async created() {
    if (this.isNew) {
      const coupon_first = storage.getItem('coupon_first')
        ? JSON.parse(storage.getItem('coupon_first'))
        : {};
      this.coupon_type = coupon_first.coupon_type;
    } else {
      this.auery();
    }
  }
}
